export const ServiceData = [
  {
    title: 'שירות תוכן ו/או מידע בתשלום חד פעמי',
    services: [
      {
        key: 'א',
        value: `קבלת או הורדת תוכן באמצעות האינטרנט, צפייה בו ו/או האזנה לו באופן חד פעמי`,
        id: 'zotDownConInd',
      },
      {
        key: 'ב',
        value: `שליחת מסרון בתשלום מיוחד לשם הצבעה במסגרת תוכנית המשודרת בטלוויזיה באופן חד פעמי`,
        id: 'zotVoteInd',
      },
      {
        key: 'ג',
        value: `מתן תרומה באמצעות שליחת מסרון באופן חד פעמי`,
        id: 'zotDonateInd',
      },
      {
        key: 'ד',
        value: `קבלת מידע שימושי באופן חד פעמי`,
        id: 'zotInfoInd',
      },
      {
        key: 'ה',
        value: `קבלת תוכן באופן חד פעמי`,
        id: 'zotRecContInd',
      },
    ],
  },
  {
    title: 'שירות תוכן ו/או מידע בתשלום מתמשך - מנוי',
    services: [
      {
        key: 'א',
        value: `קבלת או הורדת תוכן באמצעות האינטרנט צפייה בו ו/או האזנה לו שלא באופן חד פעמי (כגון מנוי להורדה או צפייה בסרט וידיאו, מנוי לשירות מוזיקה, מנוי להורדת רינגטונים, מנוי להורדת סרטי וידאו ומנוי להורדת משחקים)`,
        id: 'zcnDownConInd',
      },
      {
        key: 'ב',
        value: `קבלת תוכן ו/או מידע שלא באופן חד פעמי (כגון: מנוי לקבלת עדכוני חדשות, מנוי לקבלת תוצאות ספורט, מנוי לקבלת שאלות טריוויה , מנוי לקבלת מתכוני דיאטה)`,
        id: 'zcnRecContInd',
      },
    ],
  },
  {
    title: 'גישה לשירות פרימיום',
    services: [
      {
        key: null,
        value: `הכולל השמעת תוכן קולי או הצגת תוכן חזותי, כגון: מידע, בידור, ייעוץ, שירות היכרויות, השתתפות בתחרויות וכו', הניתן באמצעות חיוג למספר הכולל את קידומות החיוג 1-900 ו-1-901`,
        id: null,
      },
      { key: 'ב', value: `מספרים בקידומת 1-900 בתעריף של עד 50 אג' לדקה ולא יותר מ-30 ₪ לשיחה כולה`, id: 'premium0Ind' },
      { key: 'ג', value: `מספרים בקידומת 1-901 בתעריף שאינו עולה על 50 ₪ לשיחה כולה`, id: 'premium1Ind' },
    ],
  },
  {
    title: 'שירות שיחות לחו"ל',
    id: 'intlInd',
    services: [
      {
        key: '',
        value: `חלק משירותי התוכן של סלקום מחייבים שימוש בגלישה. עם חסימת שירותי הגלישה לא תוכל לעשות שימוש בשירותים אלו.`,
        id: null,
      },
      {
        key: '',
        value: `שירותי הדור השלישי של סלקום ימשיכו להינתן לך במקרה בו הינך משוייך אליהם היום (למעט שירותי הגלישה או שירותי התוכן הרלוונטיים במקרה וביקשת להחסם למי מהם).`,
        id: null,
      },
    ],
  },
  {
    title: 'פרסום ב-144',
    services: [
      {
        key: null,
        value: 'פרסום מספר/י הטלפון המחויב/ים בחשבון , במודיעין הטלפוני (" 144 ") ובאינטרנט.',
        id: 'b144Ind',
      },
    ],
  },
];
